import { connect } from "react-redux";
import { matchPath } from "react-router-dom";
import withRouter from "app/utils/hocs/withRouter";
import CollapsableQuotationPriceDetailsMobile from "app/pages/Booking/Quotation/PriceDetails/CollapsableQuotationPriceDetailsMobile";
import PriceDetails from "app/pages/Booking/Quotation/PriceDetails/PriceDetails";
import {
	calculatePreBookTotal,
	getQuoteTotalWithDelta,
	isBookingEligibleForDeposit,
	calculateCreditBasedOnQuoteBase,
} from "app/pages/Booking/bookingSelectors";
import {
	calculatePartialPaymentAmount,
	checkIfPaymentCasino4xDisponible,
	getEcheancier,
} from "app/pages/Booking/Payment/paymentSelector";
import { checkIsCreditUsageIsEnabled } from "app/reducers/partnerSelector";

const mapStateToProps = (state, ownProps) => {
	const booking = state.booking;
	const offerType = booking.offer.type;
	const currentPathname = ownProps.location.pathname;

	const isRestoreBookingSessionPage = matchPath(
		{
			path: "/booking/restoreSession",
		},
		currentPathname
	);

	const isPagePayment = matchPath(
		{
			path: "/booking/payment",
		},
		currentPathname
	);

	const isSDPPagePayment = matchPath(
		{
			path: "/sdp/booking/payment",
		},
		currentPathname
	);

	const isSDPPageQuote = matchPath(
		{
			path: "/sdp/booking/quote",
		},
		currentPathname
	);

	const mensualite = getEcheancier(state);

	const partialPaymentData = calculatePartialPaymentAmount(state);

	const included =
		isSDPPagePayment || isSDPPageQuote
			? state.ficheProduit.included
			: state.ficheProduit.included && state.ficheProduit.included[offerType];

	const notIncluded =
		isSDPPagePayment || isSDPPageQuote
			? state.ficheProduit.notIncluded
			: state.ficheProduit.notIncluded && state.ficheProduit.notIncluded[offerType];

	const isCreditEnabled = checkIsCreditUsageIsEnabled(state);
	const creditsApplied = isCreditEnabled ? calculateCreditBasedOnQuoteBase(state) : 0;
	const prebookTotal = calculatePreBookTotal(state) - creditsApplied;
	const total =
		isPagePayment || isSDPPagePayment || isRestoreBookingSessionPage
			? getQuoteTotalWithDelta(state)
			: prebookTotal;

	return {
		brand: state.brand.code,
		shop: state.shop,
		total: total,
		mensualite: mensualite.apport,
		coutCredit: mensualite.coutCredit,
		partialPayment: partialPaymentData,
		hasChildren: booking.children > 0,
		isPayment4xDisponible: checkIfPaymentCasino4xDisponible(state),
		included,
		notIncluded,
		isPagePayment: isPagePayment || isSDPPagePayment || isRestoreBookingSessionPage,
		paymentType: booking.paymentType,
		paymentMode: booking.paymentMode,
		usableCouponsStatus: state.usableCoupons.status,
		isBookingEligibleForDeposit: isBookingEligibleForDeposit(state),
	};
};

export const CollapsableQuotationPriceDetailContainerMobile = withRouter(
	connect(mapStateToProps)(CollapsableQuotationPriceDetailsMobile)
);

export const QuotationPriceDetailContainer = withRouter(connect(mapStateToProps)(PriceDetails));
